import { take, put }             from 'redux-saga/effects';
import { SET_DATA, SET_CONTENT } from '../actions';
import { set_user_activity }     from '../functions/set_data/set_user_activity';
import { updateHash }            from '../functions/rectify_data/my_encoder';
import updateContent             from '../functions/rectify_data/update_content';
import sortContent               from '../functions/rectify_data/sort_content';
//import { dev }                   from 'utils/defaultStates';


function* createData(): Generator<any,any,any> {
  while(true) {
    try {

            const input = yield take('CREATE_DATA_SAGA');

            const { content, data, hash, userEmail, variant/* , guest */ } = input.payload;

            let { bigContentArr, apps, interaction, lessons, puzzles, bigTeacherArr, mivdakim, teacherLessons } = content;

            const allActivity = data.userActivity.concat(data.totalLikes)

            const hashWithActivity: { [key: string]: any } = yield set_user_activity(userEmail, allActivity, hash);
            const finalHash         = yield updateHash(data.scores, hashWithActivity);

            const newBigContentArr  = yield updateContent(bigContentArr, finalHash)
            const newApps           = yield updateContent(apps, finalHash)
            const newInteraction    = yield updateContent(interaction, finalHash)
            const newLessons        = yield updateContent(lessons, finalHash)
            const newPuzzles        = yield updateContent(puzzles, finalHash)
            const newBigTeacherArr  = yield updateContent(bigTeacherArr, finalHash)
            const newMivdakim       = yield updateContent(mivdakim, finalHash)
            const newTeacherLessons = yield updateContent(teacherLessons, finalHash)


            const soretedBigContentArr   = yield sortContent(newBigContentArr, 'likes')
            const soretedApps            = yield sortContent(newApps, 'likes')
            const soretedInteraction     = yield sortContent(newInteraction, 'likes')
            const soretedLessons         = yield sortContent(newLessons, 'likes')
            const soretedPuzzles         = yield sortContent(newPuzzles, 'likes')
            const soretedBigTeacherArr0  = yield sortContent(newBigTeacherArr, 'likes')
            const soretedMivdakim0       = yield sortContent(newMivdakim, 'likes')
            const soretedTeacherLessons0 = yield sortContent(newTeacherLessons, 'likes')
            const soretedBigTeacherArr   = yield sortContent(soretedBigTeacherArr0, 'approved')
            const soretedMivdakim        = yield sortContent(soretedMivdakim0, 'approved')
            const soretedTeacherLessons  = yield sortContent(soretedTeacherLessons0, 'approved')


            const payload = {
              bigTeacherArr:         soretedBigTeacherArr,
              teacherLessons:        soretedTeacherLessons,
              mivdakim:              soretedMivdakim,
              bigContentArr:         soretedBigContentArr,
              apps:                  soretedApps,
              interaction:           soretedInteraction,
              puzzles:               soretedPuzzles,
              lessons:               soretedLessons,
              hash:                  finalHash,
            //  contentUpdated:        true,
              storageContentUpdated: true,
              sender:                'createData'
            }


            yield put(SET_CONTENT( payload ))
            yield put(SET_DATA({ variant: variant }))

         
            

    }
    catch(err) {
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default createData;






